import { NgModule }                from '@angular/core';
import { HttpClientModule, HttpClient }              from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  TranslateModule,
  TranslateLoader
}                                  from '@ngx-translate/core';
import { ToastrModule }            from 'ngx-toastr';

import { TranslateHttpLoader }     from '@ngx-translate/http-loader';

import { CoreModule }              from './core/core.module';
import { SharedModule }            from './shared/shared.module';
import { HeaderModule }            from './moddules/header/header.module';
import { FooterModule }            from './moddules/footer/footer.module';
import { AppConfig }               from './app.config'
import { AppRoutingModule }        from './app-routing.module';
import { AppComponent }            from './app.component';
import { HomeModule }              from './pages/home/home.module';
import { SearchResultModule }      from './pages/search/search-result.module';
import { PopupsModule }            from './popups/popups.moule';
import { ContactInfoModule }       from './pages/contact-info/contact-info.module';
import { UserProfileModule }       from './pages/user-profile/user-profile.module';
import { CartModule }              from './pages/cart/cart.module';
import { PaymentModule }           from './pages/payment/payment.module';
import { ProductModule }           from './pages/product/product.module';
import { PasswordRecoveryModule }  from './pages/password-recovery/password-recovery.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { interceptedHttp } from './http.interceptor';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    CoreModule.forRoot(new AppConfig()),
    HeaderModule,
    FooterModule,
    HomeModule,
    CartModule,
    PasswordRecoveryModule,
    PaymentModule,
    SearchResultModule,
    PopupsModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(new AppConfig()),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    ContactInfoModule,
    UserProfileModule,
    ProductModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: interceptedHttp,
      multi: true,
    }],
  declarations: [AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app.module.ts